module.exports = __webpack_public_path__ + "img/laboratorio_4-3_1024.83b9aadf.jpg";